import {Component, computed, input} from '@angular/core';
import {ScorecardRow} from "../../rows/row";
import {RowComponent} from "../../row/row.component";
import {NgForOf, NgSwitch, NgSwitchCase} from "@angular/common";
import {
    FairwayHitRow,
    GirRow,
    GrossScoreRow,
    ParticipantCard,
    ParticipantCardRowType,
    PenaltiesRow,
    PuttsRow,
    SandRow,
    ScorecardParticipantType,
    ScoreRow
} from "../../model/participant-card-model";
import {getScoreRow} from "../../rows/score-row";
import {getPuttsRow} from "../../rows/putts-row";
import {getPenaltiesRow} from "../../rows/penalties-row";
import {getGirRow} from "../../rows/gir-row";
import {getSandRow} from "../../rows/sand-row";
import {getFairwayRow} from "../../rows/fairway-row";
import {IndividualHeaderComponent} from "./individual-header/individual-header.component";
import {TeamHeaderComponent} from "./team-header/team-header.component";
import {getGrossScoreRow} from "../../rows/gross-score-row";
import {Card} from "../../model/scorecard-model";

@Component({
    selector: 'participant-card',
    templateUrl: './participant-card.component.html',
    imports: [
        RowComponent,
        NgForOf,
        NgSwitchCase,
        NgSwitch,
        IndividualHeaderComponent,
        TeamHeaderComponent
    ],
    styleUrls: ['./participant-card.component.css']
})
export class ParticipantCardComponent {
    card = input.required<Card>();

    participantCard = computed(() => {
        return this.card() as ParticipantCard
    });

    participant = computed(() => {
        return this.participantCard().participant
    });

    rows = computed(() => {
        return this.getPlayerRows(this.participantCard())
    });

    totals = computed(() => {
        return this.participantCard().totals
    });

    trackByRowName(_: number, row: ScorecardRow) {
        return row.name
    };

    private getPlayerRows(scorecard: ParticipantCard): ScorecardRow[] {
        return scorecard.rows
            .map(row => {
                switch (row.type) {
                    case ParticipantCardRowType.GrossScoreRow:
                        return getGrossScoreRow(row as GrossScoreRow)
                    case ParticipantCardRowType.ScoreRow:
                        return getScoreRow(row as ScoreRow)
                    case ParticipantCardRowType.PuttsRow:
                        return getPuttsRow(row as PuttsRow)
                    case ParticipantCardRowType.PenaltiesRow:
                        return getPenaltiesRow(row as PenaltiesRow)
                    case ParticipantCardRowType.GirRow:
                        return getGirRow(row as GirRow)
                    case ParticipantCardRowType.SandRow:
                        return getSandRow(row as SandRow)
                    case ParticipantCardRowType.FairwayHitRow:
                        return getFairwayRow(row as FairwayHitRow)
                }
            })
            .filter(row => row != null);
    }

    protected readonly ScorecardParticipantType = ScorecardParticipantType;
}
